import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import ToastOverlay from '../ToastOverlay';
import { requestAndSubscribe } from '../../services/webpush.service';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from '../../context/LocationContext';
import { supabase } from '../../services/supabase';
import '../../styles/Layout.css';

const NotifBanner = () => {
  const { business } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'granted') return;
    if (Notification.permission === 'denied') return;
    if (localStorage.getItem('notif_banner_dismissed')) return;
    setShow(true);
  }, []);

  const enable = async () => {
    setShow(false);
    const sub = await requestAndSubscribe();
    if (sub && business?.id) {
      await supabase.from('business_push_subscriptions').upsert({
        business_id: business.id,
        endpoint:    sub.endpoint,
        p256dh:      sub.keys?.p256dh,
        auth:        sub.keys?.auth,
        updated_at:  new Date().toISOString(),
      }, { onConflict: 'endpoint' });
    }
  };

  const dismiss = () => {
    localStorage.setItem('notif_banner_dismissed', '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: '#f97316', color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '10px 16px', gap: 10, fontSize: 14,
    }}>
      <span>🔔 Yeni rezervasiyalar üçün bildirişləri aktiv et</span>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button onClick={enable} style={{
          background: '#fff', color: '#f97316', border: 'none',
          borderRadius: 6, padding: '5px 12px', fontWeight: 700, cursor: 'pointer',
        }}>Aktiv et</button>
        <button onClick={dismiss} style={{
          background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,0.5)',
          borderRadius: 6, padding: '5px 10px', cursor: 'pointer',
        }}>✕</button>
      </div>
    </div>
  );
};

const BranchBar = () => {
  const { activeLocation, locations, isOwner, isAdminView } = useLocation();
  if (!isOwner || locations.length < 2 || !activeLocation || isAdminView) return null;

  const isMain = activeLocation.is_main;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '8px 20px',
      background: isMain ? '#f0fdf4' : '#fff7ed',
      borderBottom: `2px solid ${isMain ? '#bbf7d0' : '#fed7aa'}`,
      fontSize: 13,
    }}>
      <span style={{ fontSize: 15 }}>{isMain ? '🏢' : '📍'}</span>
      <span style={{ fontWeight: 600, color: isMain ? '#166534' : '#92400e' }}>
        {isMain ? 'İdarəedici hesab' : activeLocation.name}
      </span>
      {activeLocation.city && (
        <span style={{ color: '#aaa', fontSize: 12 }}>— {activeLocation.city}</span>
      )}
      {!isMain && activeLocation.address && (
        <span style={{ color: '#bbb', fontSize: 11, marginLeft: 4 }}>{activeLocation.address}</span>
      )}
    </div>
  );
};

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <NotifBanner />
      <Sidebar />
      <div className="main-content">
        <Header />
        <BranchBar />
        <div className="content">
          {children}
        </div>
      </div>
      <ToastOverlay />
    </div>
  );
};

export default Layout;
